<template>
    <rkm-row>
        <rkm-col cols="12">

            <rkm-form ref="RkmForm">

                <rkm-row class="flex-nowrap">

                    <rkm-col cols="12">
                        <rkm-row>
                            <rkm-col class="flex-grow-1">
                                <rkm-form-input-autocomplete
                                    :repository="repositories.parametrizacao.exame"
                                    :request-query-string-params="{ not_id: null }"
                                    :searchFields="fields.autocompletes.grupoExame"
                                    :validations="validations.grupoExame"
                                    label="Grupo de exame / Exame"
                                    :text-field="i => i.codigo ? `${this.formatProcedimento(i.codigo)} - ${i.nome}` : i.nome"
                                    uppercase
                                    v-model="model.grupoExame"
                                />
                            </rkm-col>
                            <rkm-col cols="auto">
                                <rkm-button
                                    :label="false"
                                    color="primary"
                                    @click="$refs.RkmForm.validate(add)"
                                >
                                    Incluir
                                </rkm-button>
                                <rkm-button
                                    :label="false"
                                    @click.stop="resetForm"
                                >
                                    Limpar
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-list
                                    :items="exames"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot="{ item }">
                                        {{ item.nome }}
                                    </template>

                                    <template v-slot:trailling="{ item }">
                                        <rkm-button
                                            @click.stop="deleteExame(item)"
                                            color="danger"
                                            title="Excluir"
                                            small
                                        >
                                            <rkm-icon icon="trash" />
                                        </rkm-button>
                                    </template>
                                </rkm-list>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-col>
    </rkm-row>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, formats } from '@/mixins'

//Enums
import tipoExame from '@/enums/parametrizacao/tipoExame'
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

export default {
    computed: {
        validations() {

            return {
                grupoExame: { required: true },
            }
        },
        fields() {

            return {
                autocompletes: {
                    grupoExame: [
                        { key: 'item.codigo', searchable: true },
                        { key: 'item.nome', searchable: true },
                    ],
                }
            }
        },
    },
    created() {
        this.repositories = {
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            parametrizacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }
    },
    data: () => ({
        exame: null,
        origem: 'exame',
        exames: [],
        selecionado: {},
        newIndex: null,
        cadastro: [],
        enums: {
            tipoExame,
            tipoUnidade,
        },
        model: {
            grupoExame: null,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        add() {

            if (this.model.grupoExame.origem === 'exame') {

                if(this.exames.find(e => e.exameId === this.model.grupoExame.id)) {
                    this.showAlert('Exame já existente.', 'Atenção')
                    this.resetForm()
                    return
                }

                this.exames.push(this.prepareData(this.model.grupoExame))

                this.resetForm()
            }
            else {

                this.getExames().then(exames => {

                    exames.forEach((exame) => {
                        if(!this.exames.find(e => e.exameId === exame.id)) {

                            this.exames.push(this.prepareData(exame))
                        }
                    })

                    this.resetForm()
                })
            }
        },
        async getExames() {

            let exames = [];

            this.setLoading()

            try {

                exames = (await this.repositories.parametrizacao.list({
                    listar: 'exames',
                    grupo_id: this.model.grupoExame.id
                })).data
            }
            catch (error) {

                this.handleError(error)
            }
            finally {

                this.unsetLoading()
            }

            return exames
        },
        prepareData(exame) {

            exame = this.clone(exame)
            exame.exameId = exame.id
            exame.id = this.uniqueId('exame' + new Date().getTime()),
            exame.ativo = true

            return exame
        },
        resetForm() {

            this.model.grupoExame = null

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
        deleteExame(item) {

            const objId = this.exames.findIndex((obj => (obj.exameId == item.exameId)));

            const destroy = async () => {

                this.exames.splice(objId, 1)
            }

            this.showDeleteConfirmation(`Deseja realmente excluir o exame <strong>${ item.nome }</strong> da lista?`,
                destroy)
        },
        handleExames(exames) {
            this.exames = exames
        }
    },
    mixins: [ repository, stringCase, object, formats ],
    props: {
        data: { type: Object, required: true},
    },
    watch: {
        'exames'(exames) {

            this.$emit('exames', exames)
        },
    }
}
</script>

